<template>
    <div class="form-group formly-input"
         :class="[ to.inputType, to.wrapperClasses, {'formly-has-value': model[field.key], 'formly-has-focus': form[field.key].$active, 'has-error has-danger': hasError}]">
        <label v-if="to.label" :for="to.id ? to.id : null">{{to.label}}</label>
        <datepicker :calendar-button="calendar" :calendar-button-icon="calendarClass" :clear-button="clear" :clear-button-icon="clearClass" :input-class="inputClass" :format="dateFormat" v-model="dateValue"></datepicker>
        <error-display :form="form" :field="field.key"></error-display>
    </div>
</template>

<script>
    import baseField from 'vue-formly-bootstrap/src/fields/baseField'
    import Datepicker from 'vuejs-datepicker'

    export default {
        mixins: [baseField],
        props: ['form', 'field', 'model', 'to'],
        name: 'DatePicker',
        components: {Datepicker},
        data () {
            return {
                dateFormat: 'yyyy-MM-dd',
                inputClass: 'form-control',
                calendar: true,
                clear: true,
                calendarClass: 'glyphicon glyphicon-calendar',
                clearClass: 'glyphicon glyphicon-remove'
            }
        },
        computed: {
            dateValue: {
                get () {
                    return this.model[this.field.key] ? this.model[this.field.key] + 'T00:00:00' : ''
                },
                set (newValue) {
                    this.model[this.field.key] = newValue ? this.$options.filters.formatDate(newValue.toISOString(), 'YYYY-MM-DD') : ''
                }
            }
        },
        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Datepicker.vue?0d641bce